/* eslint-disable no-magic-numbers */
define('core/utils/fingerprint',[], function () {
    'use strict';

    // A fairly week fingerprinting function for a given browser.
    //
    // @param {Object} deps Dependency injection. Optional. Needed for
    //                      when this code is executed on the host page,
    //                      where the built-in native objects may have
    //                      been altered.
    function getFingerprint(deps) {
        deps = deps || {};
        var Math = deps.Math || window.Math;
        var Date = deps.Date || window.Date;

        // wrap in try/catch just to make sure it won't break anything in some exotic browser
        try {
            // The time-zone offset is the difference, in minutes, between UTC and local time
            var offset = new Date().getTimezoneOffset();
            var screenRes = 1;
            var screen = window.screen;

            if (screen && screen.availWidth)
                screenRes = screen.availWidth * screen.availHeight + screen.colorDepth;
            else if (screen && screen.width)  // screen.availWidth is not supported on mobile
                screenRes = screen.width * screen.height;

            var doc = window.document.documentElement;
            var browser = doc.clientWidth * doc.clientHeight;

            // multiply values by random prime numbers just to decrease likelihood of
            // making the same sum by different summands. Subtract `browser` in order
            // to decrease output value
            return Math.abs(offset * 17 + screenRes * 25 - browser);
        } catch (err) {
            return 1;
        }
    }

    return { get: getFingerprint };
});

